// 'initial' | 'pending' | 'success' | 'failed'

export const initialApiState = {
  state: "initial",
  error: null,
  data: null,
};
